export const utils = {
  numberFromPrice: (price) => {
    // if price is not a string, return 0
    if (!price || typeof price !== "string") return 0;
    // Remove trailing zeroes and special characters
    price = price?.replace(/[^0-9.]/g, "");
    // Convert to number
    price = parseFloat(price);
    // Return number
    return price;
  },
  formatPrice: (price) => {
    if (!price) return 0;
    // Convert to number
    price = utils.numberFromPrice(price);
    // Format price
    price = price.toFixed(2);
    // Return formatted price
    return price;
  },
  // Shopify prices are in cents, convert to dollars
  formatShopifyPrice: (price) => {
    if (!price) return 0;
    // Convert to dollars
    price = price / 100;
    // Format price
    price = price.toFixed(2);
    // Return formatted price
    if (typeof price === "string") {
      price = utils.numberFromPrice(price);
    }
    return price;
  },
};
